import { memo } from 'react'

import type { AcfTravelplanProps } from '@typings'
import {
  RaContainer,
  RaGrid,
  RaGridItem,
  RaRichText,
} from '@components/core/index.core'
import { RaTravelGuides } from '@components/features/RaTravelGuides/RaTravelGuides'
import { RaTravelPlanCards } from '@components/features/RaTravelPlanCards/RaTravelPlanCards'
import { RaFormDialogButton } from '@components/form-elements/RaFormDialogButton/RaFormDialogButton'
import { translate } from '@utilities/helpers/core.helpers'

import styles from './acf-travelplan.module.scss'

export const AcfTravelplan = memo((props: AcfTravelplanProps) => {
  const {
    label,
    id,
    redirect,
    expires,
    history,
    travelplanpage_sidebar_content,
  } = props

  return (
    <RaContainer>
      <RaGrid>
        <RaGridItem
          xs={12}
          md={8}
          lg={8}>
          <div className={styles['acf-travelplan__cards']}>
            <RaTravelPlanCards />
            <RaFormDialogButton
              isTravelplan
              forwardProps={{
                title: props.title,
                close: props.close,
                image: props.image,
              }}
              label={label}
              modalTitle={translate('REQUEST_TRAVELPLAN')}
              form={{
                id,
                redirect,
                expires,
                history,
              }}
            />
          </div>
        </RaGridItem>
        <RaGridItem
          xs={12}
          md={4}
          lg={4}>
          <div className={styles['acf-travelplan__sidebar']}>
            <RaFormDialogButton
              isTravelplan
              forwardProps={{
                title: props.title,
                close: props.close,
                image: props.image,
              }}
              label={label}
              modalTitle={translate('REQUEST_TRAVELPLAN')}
              form={{
                id,
                redirect,
                expires,
                history,
              }}
            />
            <RaRichText
              decorateListsWithCheckmarks
              content={travelplanpage_sidebar_content}
            />
            <RaTravelGuides />
          </div>
        </RaGridItem>
      </RaGrid>
    </RaContainer>
  )
})
